<template>
	<div class="kudos__feed content-wrap">
		<div>
      <div class="d--flex justify-content--between align-items--center">
        <h2 v-if="!loading && kudos.length">Latests</h2>
        <h4 v-else>Recognition list is currently empty.</h4>
      </div>
      <div class="loader"></div>
      <div class="kudos__feed__container">
        <loading :loading="true" v-if="loading" />
        <div
          v-else
          v-for="(item, key) in kudos"
          :key="key"
          class="kudos__feed__container__card"
        >
          <div class="kudos__feed__container__card__header">
            <div class="kudos__feed__container__card__header__badge">
              <img v-if="item.badge_id" :src="findBadge(item.badge_id)" class="badge" />
            </div>
            <i class="material-icons primary">recommend</i>
            <p>
              <span v-text="item.user_forname + ' ' + item.user_surname"></span>
              gave
              <span v-text="item.receiver_name"></span>
              Kudos
            </p>
          </div>
          <div class="kudos__feed__container__card__body">
            <p v-text="item.message"></p>
          </div>
          <div class="kudos__feed__container__card__actions">
            <span class="flair primary-bg" v-text="item.title"></span>
            <div @click="likeItem(item)">
              <span v-text="item.likes" v-if="item.likes"></span>
              <i :disbaled="busy" :class="{ 'disabled' : busy }" class="material-icons primary" v-text="(likedItems.includes(item.id)) ? 'favorite' : 'favorite_border'"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination text--center ml--4 mt--4" v-if="pagination.totalPages > 1">
        <button
          v-if="currentChunk"
          @click="currentChunk--"
          class="btn button--colored-red control mr--2"
        >
          <i class="material-icons">arrow_back</i>
        </button>
        <button
          v-for="(page, key) in pageChunks[currentChunk]"
          :key="key"
          v-text="page"
          @click="changePage(page)"
          class="btn button--colored-primary"
          :class="{ 'btn--primary primary-bg': pagination.currentPage === page, 'ml--2': key }"
        ></button>
        <button
          v-if="currentChunk < pageChunks.length - 1"
          v-text="'...'"
          @click="currentChunk++"
          class="btn button--colored-primary ml--2"
        ></button>
        <button
          v-text="pagination.totalPages"
          @click="setLastPage()"
          class="btn button--colored-primary ml--2"
          :class="{ 'btn--primary primary-bg': pagination.currentPage === pagination.totalPages }"
        ></button>
      </div>
		</div>
	</div>
</template>

<script>
import Loading from './Loading'
import axios from 'axios'

export default {
  name: 'kudos',
  props: {
    clientId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'primary'
    }
  },
  components: {
    Loading
  },
	data: () => ({
		kudos: [],
    badges: [],
    likes: [],
		pagination: { totalPages: null },
		currentChunk: 0,
    busy: false,
    loading: false,
  }),
	computed: {
		pageChunks() {
			let pages = []
			let chunks = []

			for (let i = 1; i < this.pagination.totalPages; i++) {
				pages.push(i)
      }

			for (let i = 0; i < pages.length; i + 9) {
				let slice = pages.slice(0, 9)
				chunks.push(slice)
				pages.splice(0, 9)
      }
      
			return chunks
		},
    likedItems () {
      return this.likes.map(like => like.kudos_id)
    }
	},
	methods: {
    closeModal () {
      this.showModal = false
      this.getKudos(1)
    },
    setLastPage () {
      this.getKudos(this.pagination.totalPages)
      this.currentChunk = this.pageChunks.length - 1
    },
    changePage (page) {
      this.getKudos(page)
    },
		getKudos(page) {
			axios
				.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/kudos`, {
					params: {
						clientId: this.clientId,
						page
					}
				})
				.then(response => {
					this.kudos = response.data.data
          this.pagination = response.data.pagination
				})
		},
    async getUserLikes () {
      const { data } = await axios.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/kudos-likes`, { params: { 
        clientId: this.clientId,
        employeeId: this.userId
      }})

      this.likes = data.data
    },
    async getBadges () {
      try {
        const { data } = await axios.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/kudos-badges`, { params: {
          clientId: this.clientId
        }})

        this.badges = data.data
        
      } catch (error) {
        console.log(error)
      }
    },
    async likeItem (item) {
      if (this.busy) return
      this.busy = true
      const likeId = this.likes.find(like => like.kudos_id === item.id)

      if (this.likedItems.includes(item.id) && likeId) {
        await axios.delete(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/kudos-likes/${likeId.id}`)
        item.likes -= 1
        this.getUserLikes()
      } else {
        await axios.post(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/kudos-likes`, {
          kudos_id: item.id,
          employee_id: this.userId
        })
        item.likes += 1
        this.getUserLikes()
      }

      this.busy = false
    },
		formatDate(date) {
			let d = new Date(date)
			let month = d.getMonth() + 1
			let day = d.getDate()

			day = day < 10 ? `0${day}` : day
			month = month < 10 ? `0${month}` : month

			return `${day}/${month}/${d.getFullYear()}`
		},
    findBadge (id) {
      if (!id) return
      const badge = this.badges.find(badge => badge.id === id)
      if (!badge) return

      return badge.s3_path
    }
	},
	mounted() {
    this.loading = true
    this.getUserLikes()
    this.getKudos(1)
    this.getBadges()
    if (this.pageChunks && this.pageChunks.length) {
      if (this.pagination.currentPage === this.pagination.totalPages) {
        this.currentChunk = this.pageChunks.length - 1
      } else {
        for (let i = 0; i < this.pageChunks.length; i++) {
          let chunk = this.pageChunks[i]

          if (chunk === this.pagination.currentPage) {
            this.currentChunk = i
            break
          }
        }
      }
    }
    this.loading = false
	}
}
</script>

<style lang="scss" scoped>
  @import '../scss/kudos';
</style>
